import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "uikit";

import { copyText } from "../utils/buildReport";

type Status = "idle" | "loading" | "done" | "error";

const CopyReportButton: React.FC<CopyReportButton.Props> = ({
	labelKey,
	doneKey,
	errorKey,
	build,
	disabled,
}) => {
	const { t } = useTranslation();
	const [status, setStatus] = useState<Status>("idle");

	const onClick = useCallback(async () => {
		if (status === "loading") return;

		setStatus("loading");
		try {
			const text = await build();
			const ok = await copyText(text);
			setStatus(ok ? "done" : "error");
		} catch {
			setStatus("error");
		}

		window.setTimeout(() => setStatus("idle"), 2000);
	}, [build, status]);

	let title = t(labelKey);
	if (status === "done") title = t(doneKey);
	else if (status === "error") title = t(errorKey);

	return (
		<Button.Button
			variant="secondary"
			disabled={disabled || status === "loading"}
			icon={<Icon id="copy" size={16} />}
			text={title ?? ""}
			title={title ?? ""}
			onClick={onClick}
		/>
	);
};

declare namespace CopyReportButton {
	interface Props {
		labelKey: string;
		doneKey: string;
		errorKey: string;
		build: () => Promise<string> | string;
		disabled?: boolean;
	}
}

export default CopyReportButton;
